<template>
  <a-modal
    class="modal-container"
    :title="title"
    :width="800"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <template>
      <a-form-model
        ref="ruleForm"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
        :model="form"
        :rules="rules"
      >
        <a-row :gutter="24" style="padding-left: 22px; padding-right: 32px">
          <!--          <a-col :span="8">-->
          <!--            <a-form-model-item-->
          <!--              label="选择年级"-->
          <!--              prop="gradeId"-->
          <!--              :labelCol="{ ...itemLabelCol }"-->
          <!--              :wrapperCol="itemWrapperCol"-->
          <!--            >-->
          <!--              <j-dict-select-tag-->
          <!--                placeholder="请选择年级"-->
          <!--                v-model="form.gradeId"-->
          <!--                identityGet="gradeDict"-->
          <!--                allowClear-->
          <!--                @select="-->
          <!--                  () => {-->
          <!--                    $set(form, 'classId', undefined)-->
          <!--                    $set(form, 'studentId', undefined)-->
          <!--                  }-->
          <!--                "-->
          <!--              />-->
          <!--            </a-form-model-item>-->
          <!--          </a-col>-->
          <a-col :span="12">
            <a-form-model-item
              label="选择班级"
              prop="classId"
              :labelCol="itemLabelCol"
              :wrapperCol="itemWrapperCol"
            >
              <j-dict-select-tag
                placeholder="请选择班级"
                v-model="form.classId"
                :disabled="isDisabled"
                identityGet="classDict"
                :isShowEmpty="false"
                @select="$set(form, 'studentId', undefined)"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              label="选择学生"
              prop="studentId"
              :labelCol="itemLabelCol"
              :wrapperCol="itemWrapperCol"
            >
              <j-dict-select-tag
                placeholder="请选择学生"
                v-model="form.studentId"
                class="search-space"
                :disabled="!form.classId || isDisabled"
                :dictCode="'student_info,name,id,class_id=' + (!form.classId ? -1 : form.classId)"
                :async="true"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <!--        <a-form-model-item label="沟通时间">-->
        <!--          <a-date-picker-->
        <!--            v-model="form.date"-->
        <!--            placeholder="请选择日期"-->
        <!--            :disabled="isDisabled"-->
        <!--            style="width: 100%"-->
        <!--          />-->
        <!--        </a-form-model-item>-->
        <a-form-model-item label="问题原因">
          <j-dict-select-tag
            v-model="form.tagId"
            placeholder="请选择问题原因"
            dictCode="emotional_type"
            :disabled="isDisabled"
          />
        </a-form-model-item>
        <a-form-model-item label="详情描述">
          <a-textarea
            v-model="form.comment"
            :auto-size="{ minRows: 5, maxRows: 8 }"
            placeholder="请输入内容"
            :disabled="isDisabled"
          />
        </a-form-model-item>
      </a-form-model>
    </template>
  </a-modal>
</template>

<script>
import { postAction, putAction } from '@api/manage'
import moment from 'moment'

export default {
  name: 'CommunRecordModal',
  props: {
    title: {
      type: String,
      default: '沟通记录',
    },
  },
  data() {
    return {
      labelCol: { span: 3 },
      wrapperCol: { span: 20 },
      itemLabelCol: { span: 5 },
      itemWrapperCol: { span: 19 },
      visible: false,
      form: {},
      rules: {},
      isDisabled: false,
    }
  },
  methods: {
    showModal(data = null, type) {
      console.log('记录数据：', data)
      if (data) {
        this.form = data
      }
      if (type == 'view') {
        this.isDisabled = true
      }
      this.visible = true
    },
    hideModal() {
      this.visible = false
      this.form = {}
      this.isDisabled = false
    },
    async handleOk() {
      if (this.form.date) {
        this.form.date = moment(this.form.date).format('YYYY-MM-DD')
      }
      const params = { ...this.form, dataType: 9 }
      let res = {}
      if (this.form.id) {
        res = await putAction('/aigoes/schoolWarnRecord/edit', params)
      } else {
        res = await postAction('/aigoes/schoolWarnRecord/add', params)
      }
      if (res.success) {
        this.$message.success(res.message || '操作成功')
        this.hideModal()
        this.$emit('refreshData')
      } else {
        this.$message.error(res.message || '操作失败')
      }
    },
  },
}
</script>
<style scoped lang="less">
//.modal-container {
//  /deep/ .ant-modal-body {
//    padding: 10px 24px 24px 24px;
//  }
//  /deep/ .ant-form-item {
//    margin-bottom: 0px;
//  }
//}
</style>
